import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'
import classes from 'components/BetterList/List.scss'

import ListColumn from 'components/BetterList/Column'

export const BeforeOrderRow = ({ mapArguments, options }) => {
  let [order, rowIndex, collection] = mapArguments
  let isFirstOfCustomer = !collection[rowIndex - 1] || // no previous order
    order.customer_id !== collection[rowIndex - 1].customer_id // current order !== previous order's customer

  if (!order.order_notes || !isFirstOfCustomer) return null

  return <tr className={cx(
    classes['item--before'],
    options.includes('striped') && classes['item--striped']
  )}>
    <ListColumn key={`row-${rowIndex}:order.order_notes`} options={['full-width', 'order-notes']} colspan={100}>
      {order.order_notes}
    </ListColumn>
  </tr>
}

BeforeOrderRow.propTypes = {
  mapArguments: PropTypes.array.isRequired,
  options: PropTypes.array
}

export default BeforeOrderRow



// WEBPACK FOOTER //
// ./src/components/Orders/List/BeforeRow.js